import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "app-display",
  "use": "app-display-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol viewBox=\"0 0 50 50\" id=\"app-display\"><defs><style>#app-display .cls-1{fill:#3badf6;}#app-display .cls-2,#app-display .cls-3{fill:#fcfcfc;}#app-display .cls-3{opacity:0.8;}</style></defs><title>资源 29</title><g id=\"app-display_图层_2\" data-name=\"图层 2\"><g id=\"app-display_图层_1-2\" data-name=\"图层 1\"><rect class=\"cls-1\" width=\"50\" height=\"50\" /><path class=\"cls-2\" d=\"M38.12,11.87H11.88A1.71,1.71,0,0,0,10,13.75V31.56a1.71,1.71,0,0,0,1.88,1.88H23.13v2.81H17.5a.85.85,0,0,0-.94.94v.94H33.43v-.94a.85.85,0,0,0-.94-.94H26.87V33.43H38.12A1.71,1.71,0,0,0,40,31.56V13.75a1.71,1.71,0,0,0-1.88-1.88ZM23.93,31A1.07,1.07,0,1,1,25,32,1.08,1.08,0,0,1,23.93,31Zm-12.05-2.2v-15H38.12v15Z\" /><path class=\"cls-2\" d=\"M29.07,21.13H25V17a.2.2,0,0,0-.2-.2h0a4.54,4.54,0,1,0,4.56,4.56v0A.2.2,0,0,0,29.07,21.13Z\" /><path class=\"cls-3\" d=\"M30.14,20.46a4.54,4.54,0,0,0-4.52-4.51h0a.2.2,0,0,0-.2.2V20.5a.2.2,0,0,0,.2.2h4.36a.2.2,0,0,0,.2-.2v0Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/app-display.svg
// module id = 0KR6
// module chunks = 264